import axios from "axios";
import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "utils/ApiUrl";

const Createnewpassword = () => {
  const history = useHistory();
  const location = useLocation();
  // const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  console.log("tokennnnnn", token);
  // const { email, otpCode } = location.state || {};

  // if (!email) {
  //   history.push("/");
  // } else if (email && !otpCode) {
  //   history.push({
  //     pathname: "/Enterdigitcode",
  //     state: { email: email },
  //   });
  // }
  const passwordPattern =
    /^(?=.*[A-Za-z])(?=.*\d)(?=.*[A-Z])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,}$/;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validatePasswords = (password, confirmPassword) => {
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return false;
    }
    if (!passwordPattern.test(password)) {
      toast.error(
        "Password must be at least 8 characters long and contain both letters and numbers."
      );
      return false;
    }
    return true;
  };

  const handleCreatePass = async (e) => {
    e.preventDefault();

    if (!validatePasswords(password, confirmPassword)) return;

    const payload = {
      // otpCode: otpCode,
      // email: email,
      token: token,
      password: password,
      confirmPassword: confirmPassword,
    };

    try {
      const response = await axios.post(
        `${API_URL}/auth/users/reset-password`,
        payload,
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("reset-password api response: ", response?.data);
      toast.success(response?.data?.message);
      history.push("/Login");
    } catch (error) {
      console.log("Error in reset-password api: ", error);
      if (error?.response) {
        console.log("Error in reset-password api: ", error?.response);
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("An error occurred while sending the request.");
      }
    }
  };

  return (
    <>
      <section className="mainlogin">
        {/* Right Side: Image */}
        <div className="login-image">
          {/* Uncomment and use a meaningful image */}
          {/* <img src="/loginbg.png" alt="Login Illustration" /> */}
        </div>
        {/* Left Side: Login Form */}
        <div className="login-form">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="181"
            height="37"
            viewBox="0 0 181 37"
            fill="none"
          >
            <path
              d="M0 36.5798C9.56929 24.0421 27.192 14.261 27.192 14.261C27.192 14.261 45.5809 24.2086 54.384 36.5798C45.5856 16.5365 27.192 0.42041 27.192 0.42041C27.192 0.42041 9.56929 16.2642 0 36.5798Z"
              fill="#FF8A00"
            />
            <path
              d="M0.139404 36.424C9.71106 31.1198 27.3314 26.9811 27.3314 26.9811C27.3314 26.9811 45.7203 31.1911 54.5234 36.424C45.7273 27.9431 27.3314 21.1272 27.3314 21.1272C27.3314 21.1272 9.71106 27.8294 0.139404 36.424Z"
              fill="#FF8A00"
            />
            <path
              d="M0.139404 36.4239C9.71106 34.1801 27.3314 32.4226 27.3314 32.4226C27.3314 32.4226 45.7203 34.2012 54.5234 36.4159C45.7273 32.8296 27.3314 29.9436 27.3314 29.9436C27.3314 29.9436 9.71106 32.7873 0.139404 36.4239Z"
              fill="#FF8A00"
            />
            <path
              d="M71.1148 28.1225C67.0239 28.1225 64.3296 26.1945 64.1195 22.9935L64.1072 22.8081H67.1599L67.1846 22.9564C67.4194 24.4889 68.989 25.4406 71.2261 25.4406C73.4754 25.4406 74.8844 24.4395 74.8844 22.907V22.8946C74.8844 21.5598 73.9574 20.843 71.6586 20.361L69.743 19.9655C66.233 19.2363 64.5027 17.6049 64.5027 14.9477V14.9353C64.515 11.7961 67.2711 9.67031 71.1148 9.67031C75.008 9.67031 77.5539 11.7219 77.7393 14.7746L77.7517 14.9847H74.699L74.6743 14.8364C74.4642 13.2792 73.0923 12.3522 71.0901 12.3522C69.0014 12.3646 67.7037 13.341 67.7037 14.7623V14.7746C67.7037 16.0353 68.6801 16.7768 70.8306 17.2218L72.7586 17.6173C76.4663 18.3835 78.0854 19.8913 78.0854 22.6721V22.6845C78.0854 26.0091 75.4652 28.1225 71.1148 28.1225Z"
              fill="#10312B"
            />
            <path
              d="M80.1617 27.8136V14.7128H83.2392V16.8139H83.301C83.8571 15.3802 85.2043 14.4409 86.9345 14.4409C88.7637 14.4409 90.0861 15.405 90.5681 17.0858H90.6423C91.2726 15.4544 92.8299 14.4409 94.7208 14.4409C97.3039 14.4409 98.9971 16.1959 98.9971 18.8161V27.8136H95.9197V19.5824C95.9197 17.9633 95.0792 17.0364 93.5714 17.0364C92.0883 17.0364 91.0749 18.1363 91.0749 19.7183V27.8136H88.0839V19.4217C88.0839 17.9509 87.1941 17.0364 85.7604 17.0364C84.2773 17.0364 83.2392 18.1981 83.2392 19.7925V27.8136H80.1617Z"
              fill="#10312B"
            />
            <path
              d="M105.337 28.036C102.717 28.036 100.95 26.417 100.95 24.0811V24.0564C100.95 21.7329 102.754 20.3363 105.931 20.1385L109.354 19.9284V19.0262C109.354 17.7038 108.489 16.9004 106.932 16.9004C105.473 16.9004 104.583 17.5802 104.386 18.5442L104.361 18.6554H101.506L101.518 18.5071C101.704 16.1836 103.718 14.4409 107.043 14.4409C110.318 14.4409 112.431 16.1712 112.431 18.8037V27.8136H109.354V25.799H109.28C108.526 27.1709 107.068 28.036 105.337 28.036ZM104.015 23.9575C104.015 25.0327 104.905 25.6878 106.252 25.6878C108.019 25.6878 109.354 24.5137 109.354 22.9564V21.9677L106.363 22.1531C104.843 22.2519 104.015 22.907 104.015 23.9451V23.9575Z"
              fill="#10312B"
            />
            <path
              d="M114.916 27.8136V14.7128H117.993V16.9746H118.055C118.463 15.3926 119.55 14.4409 121.058 14.4409C121.441 14.4409 121.8 14.5027 122.035 14.5645V17.3453C121.775 17.2465 121.305 17.1723 120.786 17.1723C119.044 17.1723 117.993 18.2723 117.993 20.2127V27.8136H114.916Z"
              fill="#10312B"
            />
            <path
              d="M128.486 28.0731C125.742 28.0731 124.445 26.9608 124.445 24.2665V17.0858H122.591V14.7128H124.445V11.3882H127.571V14.7128H130.006V17.0858H127.571V24.0069C127.571 25.2923 128.14 25.7001 129.265 25.7001C129.561 25.7001 129.796 25.6631 130.006 25.6507V27.9619C129.648 28.0113 129.104 28.0731 128.486 28.0731Z"
              fill="#10312B"
            />
            <path
              d="M145.257 28.1225C140.128 28.1225 136.89 24.5878 136.89 18.8902V18.8779C136.89 13.1803 140.141 9.67031 145.257 9.67031C149.361 9.67031 152.376 12.2287 152.846 15.8623L152.858 15.9858H149.731L149.67 15.751C149.151 13.7118 147.581 12.4388 145.257 12.4388C142.143 12.4388 140.153 14.923 140.153 18.8779V18.8902C140.153 22.8575 142.155 25.3541 145.257 25.3541C147.532 25.3541 149.126 24.1305 149.707 21.9306L149.744 21.807H152.871L152.846 21.9306C152.389 25.5889 149.361 28.1225 145.257 28.1225Z"
              fill="#10312B"
            />
            <path
              d="M156.615 12.8343C155.651 12.8343 154.898 12.068 154.898 11.1534C154.898 10.2141 155.651 9.46021 156.615 9.46021C157.58 9.46021 158.321 10.2141 158.321 11.1534C158.321 12.068 157.58 12.8343 156.615 12.8343ZM155.071 27.8136V14.7128H158.148V27.8136H155.071Z"
              fill="#10312B"
            />
            <path
              d="M165.638 28.0731C162.894 28.0731 161.596 26.9608 161.596 24.2665V17.0858H159.742V14.7128H161.596V11.3882H164.723V14.7128H167.158V17.0858H164.723V24.0069C164.723 25.2923 165.292 25.7001 166.416 25.7001C166.713 25.7001 166.948 25.6631 167.158 25.6507V27.9619C166.799 28.0113 166.256 28.0731 165.638 28.0731Z"
              fill="#10312B"
            />
            <path
              d="M171.026 32.164C170.433 32.164 169.815 32.0898 169.444 32.028V29.6798C169.679 29.7292 170.038 29.791 170.47 29.791C171.644 29.791 172.299 29.4573 172.695 28.3574L172.88 27.8259L168.171 14.7128H171.533L174.598 25.1934H174.685L177.762 14.7128H181L176.291 28.2585C175.29 31.1382 173.758 32.164 171.026 32.164Z"
              fill="#10312B"
            />
          </svg>
          <h2>Create new Password</h2>
          <form className="forremsbs" onSubmit={handleCreatePass}>
            <div className="form-group onlyforpositoninput">
              <label htmlFor="password">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                style={{ paddingRight: "40px" }}
                required
              />
              <span
                className="eyeonlyyysss"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "👁️" : "👁️‍🗨️"}
              </span>
            </div>
            <div className="form-group onlyforpositoninput">
              <label htmlFor="password">Confirm Password</label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="password"
                placeholder="Confirm your password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                }}
                required
              />
              <span
                className="eyeonlyyysss"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? "👁️" : "👁️‍🗨️"}
              </span>
            </div>

            {/* <Link to="/Signup"> */}
            <button className="btn-login" type="submit">
              Create Password
            </button>
            {/* </Link> */}
          </form>
        </div>
      </section>
    </>
  );
};

export default Createnewpassword;
